import { types } from "mobx-state-tree";
import { LessonStore as Lesson } from "./Lesson/LessonStore";

export const ChapterStore = types
  .model({
    id: types.identifierNumber,
    name: types.maybeNull(types.string),
    lessons: types.array(types.reference(types.late(() => Lesson))),
  })
  .views((self) => ({
    get duration() {
      let chapterDuration = 0;

      for (const lesson of self.lessons) {
        chapterDuration += lesson.duration;
      }
      return chapterDuration;
    },

    get progress() {
      return self.lessons.filter((lesson) => lesson.isDone).length;
    },
  }));
